<template>
  <div>
    <Upload type="drag"
            action="/"
            :before-upload="handleUpload">
      <slot></slot>
    </Upload>
    <slot name="info"></slot>
  </div>
</template>

<script>
import { ossOpen, ossOpenUgd, ossSecret, ossSecretUgd } from '@/api/oss'
import { randomString } from '@/libs/tools'

export default {
  name: 'upload-wrapper',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: undefined
    },
    format: {
      type: Array,
      default: () => {
        return []
      }
    },
    secret: {
      type: Boolean,
      default: true
    },
    productLine: {
      type: String,
      default: 'MASTER'
    },
    path: {
      type: String,
      required: true
    },
    randomLength: {
      type: Number,
      default: 0
    },
    // MB
    size: {
      type: [Number]
    }
  },
  methods: {
    handleUpload (file) {
      this.$emit('on-before-upload')
      this.$emit('input', {})
      let valid = this.validate(file)
      if (valid) {
        this.upload(file)
      }
      return false
    },
    validate (file) {
      let type = file.name.substring(file.name.lastIndexOf('.') + 1)
      let format = this.format
      // 判断格式
      if (format.length > 0 && !format.includes(type)) {
        this.$emit('on-type-error')
        return false
      }
      console.log(this.size, file.size)
      // 判断大小
      if (this.size && file.size > this.size * 1024 * 1024) {
        console.log('222')
        this.$emit('on-size-error')
        return false
      }
      // 判断文件名字是否含有+
      if (file.name.indexOf('+') !== -1) {
        this.$emit('on-name-error')
        return false
      }
      return true
    },
    upload (file) {
      this.ossSts().then(res => {
        let sts = res.data
        this.client = new OSS.Wrapper({
          region: 'oss-cn-beijing',
          accessKeyId: sts.accessid,
          secure: true,
          endpoint: sts.endpoint,
          accessKeySecret: sts.accessKey,
          bucket: sts.bucket
        })
        let the = this
        this.client.multipartUpload(this.uploadPath(file), file, {
          progress: async function (p, checkpoint) {
            the.progress = p
          }
        }).then(res => {
          let result = {
            originFilename: file.name
          }
          if (this.secret) {
            result.url = res.name
          } else {
            result.url = `https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/${res.name}`
          }
          the.$emit('on-success', result)
        })
      })
    },
    ossSts () {
      if (this.secret) {
        if (this.productLine === 'UNDERGRADUATE') {
          return new Promise(resolve => {
            ossSecretUgd({ dir: this.path }).then(res => {
              resolve(res)
            })
          })
        } else if (this.productLine === 'MASTER') {
          return new Promise(resolve => {
            ossSecret({ dir: this.path }).then(res => {
              resolve(res)
            })
          })
        }
      } else {
        if (this.productLine === 'UNDERGRADUATE') {
          return new Promise(resolve => {
            ossOpenUgd({ dir: this.path }).then(res => {
              resolve(res)
            })
          })
        } else if (this.productLine === 'MASTER') {
          return new Promise(resolve => {
            ossOpen({ dir: this.path }).then(res => {
              resolve(res)
            })
          })
        }
      }
    },
    trimDelimiter (value) {
      return value.replace(/^\//, '').replace(/\/$/, '')
    },
    uploadPath (file) {
      let path
      let root
      let filename = file.name
      if (this.secret) {
        root = 'beijing/docs/mentee'
      } else {
        root = 'beijing/public/mentee'
      }
      if (this.randomLength) {
        filename = randomString(this.randomFilenameLength)
      }
      if (this.productLine === 'UNDERGRADUATE') {
        path = `${root}/undergraduate${this.trimDelimiter(this.path)}/${this.trimDelimiter(filename)}`
      } else if (this.productLine === 'MASTER') {
        path = `${root}/master/${this.trimDelimiter(this.path)}/${this.trimDelimiter(filename)}`
      }
      return path
    }
  }
}
</script>

<style scoped>
</style>
